export const codingLangVersion = {
  javascript: "18.15.0",
  python: "3.10.0",
  csharp: "5.0.201",
  java: "15.0.2",
  ruby: "3.0.1",
  php: "8.2.3",
};

export const templateCode = {
  javascript: `// JavaScript Starter Code
function sayHello(name) {
  console.log(\`Hello, \${name}!\`);
}

sayHello("World");
`,

  python: `# Python Starter Code
def say_hello(name):
    print(f"Hello, {name}!")
  
say_hello("World")
`,

  csharp: `// .NET Starter Code (C# Example)
using System;

class Program {
    static void Main(string[] args) {
        Console.WriteLine("Hello, World!");
    }
}
`,

  java: `// Java Starter Code
public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}
`,

  ruby: `# Ruby Starter Code
def say_hello(name)
  puts "Hello, #{name}!"
end

say_hello("World")
`,

  php: `<?php
// PHP Starter Code
function sayHello($name) {
    echo "Hello, $name!";
}

sayHello("World");
?>
`,
};
